export enum Source {
  CLAIM = "claims",
  SIGNAL_EVENT_OCCURRENCE = "seo",
}

export type EventSource = Source.CLAIM | Source.SIGNAL_EVENT_OCCURRENCE;

export interface EventPageState {
  events_filter: string; // filter, quick filter, and table filter
  vehicles_filter: string; // filter and quick filter
  events_table_sort?: string;
  selected_group_by_attribute?: string;
  event_type: EventSource;
}

/**
 * State of a dynamic-schema page (analytics, investigator, records, or a single
 * record). Unlike {@link EventPageState}, dynamic schemas have no fixed event
 * type, so the schema is identified by `table_type` + `schema_name` instead.
 */
export interface SchemaPageState {
  table_type: string;
  // Absent on the /investigations/:id route until the investigation loads and
  // reveals its schema.
  schema_name?: string;
  events_filter?: string;
  assets_filter?: string;
  events_table_sort?: string;
  selected_group_by_attribute?: string;
  record_id?: string;
  investigation_id?: string;
  smart_group_id?: string;
}

export interface AppState {
  pathname: string;
  fullscreen_duck: boolean;
  selected_tab?: string;
  claim_analytics?: EventPageState;
  signal_event_analytics?: EventPageState;
  investigator?: EventPageState;
  dashboard?: EventPageState;
  dynamic_schema?: SchemaPageState;
}
